import React from 'react';
import * as Sentry from '@sentry/react';
import { StyledContainerLoader, StyledLoader } from '../../page/styled';

export function LoadingScreen() {
  return (
    <StyledContainerLoader role="status" aria-label="Loading">
      <StyledLoader
        type="Bars"
        color="var(--tol-header-accent, #00996b)"
        height={60}
        width={60}
      />
    </StyledContainerLoader>
  );
}

export default class AppRecovery extends React.Component {
  state = { failed: false, fallback: false };
  attempts = 0;
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error, info) {
    try {
      Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
    } catch {
      /* Reporting must not block recovery. */
    }
    if (this.attempts === 0) {
      this.attempts += 1;
      this.timer = setTimeout(() => this.setState({ failed: false }), 400);
    } else {
      this.props.onRecover?.();
      this.setState({ fallback: true });
    }
  }
  componentWillUnmount() {
    clearTimeout(this.timer);
  }
  render() {
    if (this.state.fallback) return this.props.fallback;
    return this.state.failed ? <LoadingScreen /> : this.props.children;
  }
}
